var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossFilledRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#D12F23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7595 8.51368C14.96 8.31336 15.2846 8.31334 15.4851 8.51368C15.6856 8.71423 15.6856 9.03972 15.4851 9.24025L12.7253 11.999L15.4802 14.7539C15.6807 14.9545 15.6807 15.279 15.4802 15.4795C15.2797 15.68 14.9552 15.68 14.7546 15.4795L11.9997 12.7246L9.24096 15.4854C9.04042 15.6859 8.71492 15.6859 8.5144 15.4854C8.31406 15.2849 8.31408 14.9603 8.5144 14.7598L11.2742 11.999L8.5144 9.24025C8.31385 9.0397 8.31386 8.71421 8.5144 8.51368C8.71494 8.31315 9.04043 8.31314 9.24096 8.51368L11.9997 11.2725L14.7595 8.51368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilledRedCircle);
export default __webpack_public_path__ + "static/media/CROSS_FILLED_RED_CIRCLE.f611b7651e965ba904fd5f8e6191fa17.svg";
export { ForwardRef as ReactComponent };